import { Card, CardContent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import {
    getStoresAllAnalysis,
    getStoresInitData,
    getNewSubsTM,
    getAllSubsTM,
} from './utils';
import BarChart from '../../components/charts/BarChart';
import DollarImg from '../../assets/dollar.svg'
import CartImg from '../../assets/cart.svg';
import { Padding } from '@mui/icons-material';
import TableFooter from '../../components/Tables/tableFooter';
import { AreaChart } from '../../components/charts/AreaChart';
import Spinner from '../../components/common/spinner';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { LoadingSection } from '../../components/common/loading';
import ServerError, { SectionServerErr } from '../../components/common/serverError';
import countImage from '../../assets/count.png'
import CallIcon from '../../assets/call-icon.png'
// import HourIcon from '../../assets/hours-icon.png'
import saleImage from '../../assets/sale.png'
import dollarImage from '../../assets/dollars.png'
import callImage from '../../assets/callimge.png'
import { getAllstoresAnalysis, getwholeAnalysis } from '../Merchant/utils';


const AnalysisSection = () => {
    const [allAnalysis, setAllAnalysis] = useState({ minutes: [], quantity: [], sales: [], error: false });
    const [subs, setSubs] = useState({ minutes: [], money: [], load: false, error: false });
    const [subsFilter, setSubsFilter] = useState({
        label: "New Subs this month",
        value: "ntm",
        backup: {},
        open: false,
        load: false,
        error: false,
        start: 0,
        end: 0,
        hasNext: true,
    })
    const [productsFilter, setProductsFilter] = useState({
        value: new Date().getFullYear(),
        backup: {},
        open: false,
        load: false,
        error: false,
        start: 0,
        end: 0,
        hasNext: true,
    })
    const [mainErr, setMainErr] = useState(false)
    const [count, setCount] = useState(0)
    const [anaCase, setAnaCase] = useState("m")
    const [subsCase, setSubsCase] = useState("m")
    const [storesIds, setStoresIds] = useState({ data: [], count: 0 });
    const [fetchLoad, setFetchLoad] = useState(true);
    const [isInit, setIsInit] = useState(true);
    const [nOfRes, setNOfRes] = useState(3);
    const [wholeData, setWholeData] = useState({
        totalAmount: 0,
        totalQuantity: 0,
        totalMinutes: 0,
        totalCalls: 0,
    })

    const getNextStores = async () => {
        const { data, ids, count, error } = await getStoresInitData(isInit)
        if (!error) {
            setStoresIds(p => ({ count, data: [...p.data, ...ids] }));
            setIsInit(false)
        }
        return { data, ids, error };
    }
    const getWholeAna = async () => {
        const { data, error } = await getAllstoresAnalysis()
        if (!error) {
            setWholeData(data);
        } else {
            setMainErr(true)
        }
    }
    const getAllanalysis = async (list) => {
        const { data: products, error } = await getStoresAllAnalysis(list)
        // console.log(products,"allProducts")
        products.minutes.length > 0 && setAllAnalysis(p => ({
            ...p,
            minutes: [...p.minutes, ...products.minutes],
            sales: [...p.sales, ...products.sales],
            quantity: [...p.quantity, ...products.quantity],
        }))
        setProductsFilter(p => ({
            ...p,
            start: 0,
            end: nOfRes,
            hasNext: true,
        }))
    }
    const formatAnalysis = (data) => {
        let obj = { minutes: [], quantity: [], sales: [], }
        for (let key of data) {
            obj.minutes.push(key.minutes)
            obj.quantity.push(key.quantity)
            obj.sales.push(key.sales);
        }
        setAllAnalysis(p => ({
            ...p,
            minutes: [...p.minutes, ...obj.minutes],
            sales: [...p.sales, ...obj.sales],
            quantity: [...p.quantity, ...obj.quantity],
        }))

    }
    const getNewSubstm = async (ids, value) => {
        const { data, error } = await getNewSubsTM(ids);
        setSubs(p => ({ minutes: data.minutes, money: data.money }))
        setSubsFilter(p => ({
            ...p,
            start: 0,
            end: nOfRes,
            hasNext: true,
            // backup: {
            //     ...p.backup,
            //     [value]: {
            //         minutes: data.minutes,
            //         money: data.money,
            //         hasNext: true,
            //     }
            // }
        }))
    }
    const onNextSubs = async (end, nofItems, hasNext, setItems) => {
        // console.log("clickedonextSubs")
        if (!hasNext) return
        //if not load all stores;
        setSubsFilter(p => ({
            ...p,
            load: true,
        }))
        if (storesIds.data.length <= end
            && end < storesIds.count
            && storesIds.data.length < storesIds.count
            // && storesIds.data.length<
        ) {
            const lastItem = storesIds.data[storesIds.data.length - 1]
            // console.log("lastItem",lastItem)
            const { data, ids, error: storeErr } = await getStoresInitData(false, lastItem);
            // console.log(storeErr,"storErr")
            if (storeErr) return setSubsFilter(p => ({
                ...p,
                load: false,
                error: "Something went wrong",
                hasNext: false,
            }))
            setStoresIds(p => ({
                ...p,
                data: [...p.data, ...ids]
            }))
            const list = storesIds.data.slice(end, end + nofItems);
            const selected = subsFilter.value
            const current = new Date()
            const month = current.getMonth();
            let startDate
            let endDate

            if (selected == "alm") {
                startDate = new Date(current.getFullYear(), month - 1, 1, 0, 0, 0);
                endDate = new Date(current.getFullYear(), month, 0, 23, 59, 59);
            } else if (selected == "atm") {
                endDate = new Date();
                startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1, 0, 0, 0)

            }
             const { data: sub, error } = selected !== "ntm" ? await getAllSubsTM(ids, startDate, endDate) : await getNewSubsTM(ids);
            if (error) return setSubsFilter(p => ({
                ...p,
                load: false,
                error: "Something went wrong",
                hasNext: false,
            }))

            setSubs(p => ({ ...p, minutes: [...p.minutes, ...sub.minutes], money: [...p.money, ...sub.money] }))
           const isLess = (sub.minutes.length < nofItems)
            setItems(p => {
                // console.log("subsOnext afterIpdate ", p.value, p.backup[p.value], end, nofItems)
                return ({
                    ...p,
                    start: end,
                    end: isLess ? end + sub.minutes.length : end + nofItems,
                    load: false,
                    hasNext: !(sub.minutes.length < nofItems),
                    // backup: {
                    //     ...p.backup,
                    //     [p.value]: {
                    //         minutes: [...p.backup[p.value].minutes, ...sub.minutes],
                    //         money: [...p.backup[p.value].money, ...sub.money],
                    //         hasNext: !(sub.minutes.length < nofItems),
                    //     }
                    // }
                })
            })
        } else {
            // console.log("here on not calling getnextstores")
            // if(storesIds.count===storesIds.data.length) return setSubsFilter(p=>({
            //     ...p,
            //     load:false,
            //     hasNext:false,
            //     // backup: {
            //     //     ...p.backup,
            //     //     [p.value]: {
            //     //         ...p.backup[p.value],
            //     //         hasNext: false,
            //     //     }
            //     // }
            // }))
            const list = storesIds.data.slice(end, end + nofItems);
            if (!list.length) return setSubsFilter(p => ({
                ...p,
                load: false,
                hasNext: false,
                // backup: {
                //     ...p.backup,
                //     [p.value]: {
                //         ...p.backup[p.value],
                //         hasNext: false,
                //     }
                // }
            }))
            // console.log("ids to be sent onNextSub",list)
            const selected = subsFilter.value
            const current = new Date()
            const month = current.getMonth()
            let startDate
            let endDate
            // const { data: sub, error } = await getNewSubsTM(list)
            if (selected == "alm") {
                startDate = new Date(current.getFullYear(), month - 1, 1, 0, 0, 0);
                endDate = new Date(current.getFullYear(), month, 0, 23, 59, 59);
            } else if (selected == "atm") {
                endDate = new Date();
                startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1, 0, 0, 0)

            }
            // console.log("onnext atm oralm",startDate,endDate)
            const { data: sub, error } = selected !== "ntm" ? await getAllSubsTM(list, startDate, endDate) : await getNewSubsTM(list);
            if (error) return setSubsFilter(p => ({
                ...p,
                load: false,
                error: "Something went wrong",
                hasNext: false,
            }))
            subs.minutes.length > 0 && setSubs(p => ({ ...p, minutes: [...p.minutes, ...sub.minutes], money: [...p.money, ...sub.money] }))
            // console.log(setItems,"setItems")
            const isLess = sub.minutes.length < nofItems
            setItems(p => {
                return ({
                    ...p,
                    start: end,
                    end: isLess ? end + subs.minutes.length : end + nofItems,
                    load: false,
                    hasNext: !(sub.minutes.length < nofItems),
                    // backup: {
                    //     ...p.backup,
                    //     [p.value]: {
                    //         minutes: [...p.backup[p.value].minutes, ...sub.minutes],
                    //         money: [...p.backup[p.value].money, ...sub.money],
                    //         hasNext: !(sub.minutes.length < nofItems),
                    //     }
                    // }
                })
            })
        }

    }
    const onNextProducts = async (end, nofItems, hasNext, setItems) => {
        // console.log("clickedonextSubs")
        if (!hasNext) return
        //if not load all stores;
        setProductsFilter(p => ({
            ...p,
            load: true,
        }))
        if (storesIds.data.length <= end
            && end < storesIds.count
            && storesIds.data.length < storesIds.count
        ) {
            const lastItem = storesIds.data[storesIds.data.length - 1]
            const { data, ids, error: storeErr } = await getStoresInitData(false, lastItem);
            if (storeErr) return setProductsFilter(p => ({
                ...p,
                load: false,
                error: "Something went wrong",
                hasNext: false,
            }))
            setStoresIds(p => ({
                ...p,
                data: [...p.data, ...ids]
            }))
            const list = storesIds.data.slice(end, end + nofItems);
            const selected = productsFilter.value
            const { data: products, error } = await getStoresAllAnalysis(ids);
            if (error) return setProductsFilter(p => ({
                ...p,
                load: false,
                error: "Something went wrong",
                hasNext: false,
            }))
            products.minutes.length > 0 && setAllAnalysis(p => ({
                ...p,
                minutes: [...p.minutes, ...products.minutes],
                sales: [...p.sales, ...products.sales],
                quantity: [...p.quantity, ...products.quantity],
            }))
            // console.log(setItems,"setItems")
            const isLess = products.minutes.length < nofItems
            setItems(p => {
                return ({
                    ...p,
                    start: end,
                    end: isLess ? end + products.minutes.length : end + nofItems,
                    load: false,
                    hasNext: !(isLess),

                })
            })
        } else {

            const list = storesIds.data.slice(end, end + nofItems);
            if (!list.length) return setSubsFilter(p => ({
                ...p,
                load: false,
                hasNext: false,
                // backup: {
                //     ...p.backup,
                //     [p.value]: {
                //         ...p.backup[p.value],
                //         hasNext: false,
                //     }
                // }
            }))
            // console.log("ids to be sent onNextSub",list)
            const selected = subsFilter.value

            const { data: products, error } = await getStoresAllAnalysis(list);
            if (error) return setProductsFilter(p => ({
                ...p,
                load: false,
                error: "Something went wrong",
                hasNext: false,
            }))
            products.minutes.length > 0 && setAllAnalysis(p => ({
                ...p,
                minutes: [...p.minutes, ...products.minutes],
                sales: [...p.sales, ...products.sales],
                quantity: [...p.quantity, ...products.quantity],
            }))
            // console.log(setItems,"setItems")
            const isLess = products.minutes.length < nofItems
            setItems(p => {
                // console.log("subsfu", p.value, p.backup[p.value], end, nofItems)
                return ({
                    ...p,
                    start: end,
                    end: isLess ? end + products.minutes.length : end + nofItems,
                    load: false,
                    hasNext: !(products.minutes.length < nofItems),

                })
            })
        }

    }
    const productsOptions = () => {
        const current = new Date();
        let arr = [current.getFullYear()];
        let start = 2022
        while (start < +current.getFullYear()) {
            arr.push(start)
            start++
        }
        // arr.push(+current.getFullYear())
        return arr
    }
    const getFilterSubs = async (ids, value) => {
        // console.log("selected and checking old",value, subsFilter.backup[value])
        // if (subsFilter.backup[value]) {
        //     setSubs(p => ({
        //         ...p,
        //         minutes: subsFilter.backup[value].minutes,
        //         money: subsFilter.backup[value].money,
        //     }))
        //     setSubsFilter(p => {
        //         console.log(value, 'itsoldValue', p.backup[value])
        //         return ({
        //             ...p,
        //             hasNext: p.backup[value].hasNext,

        //             load: false,
        //             start: 0,
        //             end: nOfRes,
        //         })
        //     })
        //     return
        // }
        setSubsFilter(p => ({
            ...p,
            start: 0,
            end: 0,
        }))
        const current = new Date()
        const month = current.getMonth()
        let start
        let end

        if (value == "alm") {
            start = new Date(current.getFullYear(), month - 1, 1, 0, 0, 0);
            end = new Date(current.getFullYear(), month, 0, 23, 59, 59);
        } else if (value == "atm") {
            end = new Date();
            start = new Date(end.getFullYear(), end.getMonth(), 1, 0, 0, 0)

        }
        const { data, error } = value !== "ntm" ? await getAllSubsTM(ids, start, end) : await getNewSubsTM(ids);
        if (error)return setSubs(p => ({
            ...p,
            error: true,
        }))
        setSubs(p => ({ minutes: data.minutes, money: data.money ,error:false}))
        setSubsFilter(p => ({
            ...p,
            load: false,
            hasNext: true,
            start: 0,
            end: nOfRes,
            // backup: {
            //     ...p.backup,
            //     [value]: {
            //         minutes: data.minutes,
            //         money: data.money,
            //         hasNext: true
            //     }
            // }
        }))
    }
    const subsFilters = () => {
        const obj = {
            "New Subs this month": "ntm",
            "All subs this month": "atm",
            "All subs last month": "alm",
        }
        return [
            { label: "New Subs this month", value: "ntm" },
            { label: "All subs this month", value: "atm" },
            { label: "All subs last month", value: "alm" },

        ];
    }
    const handelSelectSubsFilter = async (e, select) => {
        e.stopPropagation()
        if (select.label == subsFilter.label) return setSubsFilter(p => ({
            ...p,
            open: false,
        }));
        setSubsFilter(p => ({
            ...p,
            value: select.value,
            label: select.label,
            load: true,
            open: false,
        }));
        await getFilterSubs(storesIds.data.slice(0, nOfRes), select.value)

    }
    const getFilterProduct = async (ids, value) => {
        setProductsFilter(p => ({
            ...p,
            start: 0,
            end: 0,
        }))
        const { data: products, error } = await getStoresAllAnalysis(ids)
        if(error)setAllAnalysis(p=>({
            ...p,
            error:true,
        }))
        products.minutes.length > 0 && setAllAnalysis(p => ({
            ...p,
            error:false,
            minutes: [...p.minutes, ...products.minutes],
            sales: [...p.sales, ...products.sales],
            quantity: [...p.quantity, ...products.quantity],
        }))

        setProductsFilter(p => ({
            ...p,
            load: false,
            hasNext: true,
            start: 0,
            end: nOfRes,
        }))
    }
    const handelSelectProductsFilter = async (e, select) => {
        e.stopPropagation()
        if (select == productsFilter.value) return setProductsFilter(p => ({
            ...p,
            open: false,
        }));
        setProductsFilter(p => ({
            ...p,
            value: select,
            load: true,
            open: false,
        }));
        await getFilterProduct(storesIds.data.slice(0, nOfRes), select)

    }
    useEffect(() => {
        (async () => {
            await getWholeAna()
        })()
    }, [])
    useEffect(() => {
        count === 0 && (async () => {
            const { data, ids, error } = await getNextStores();
            if (error) {
                setAllAnalysis(p => ({ ...p, error: true }))
                setFetchLoad(false)
                setMainErr(true);
                return
            }
            await getAllanalysis(ids)
            await getNewSubstm(ids, "ntm")
            setCount(1)
        })()
    }, [count])
    return (
        mainErr ? <div style={{
            margin: "20px 0px",
            border: "1px solid lightgray",
            borderRadius: 8,
            width: "90%",
            boxShadow: "0px 4px 6px -4px rgba(58, 53, 65, 0.1), 0px 6px 10px -4px rgba(58, 53, 65, 0.08), 0px 4px 8px -4px rgba(58, 53, 65, 0.16)"
        }}>
            <ServerError />
        </div>
            : <div style={{ width: "90%", height: "fit-content", marginTop: "20px" }}>
                <p style={{fontSize:24,}}>All Stores analysis for whole history</p>
                <div className="ana-history" style={{
                    padding: "20px 0px",
                    display: "flex",
                    flexWrap: "wrap"
                    // justifyContent:"space-between"
                }}>
                    <div className='ana-hist-card'>
                        {/* left */}
                        <div style={{
                            marginRight: 10
                        }}>
                            <img src={dollarImage} alt="count-img" />
                        </div>
                        <div style={{
                            fontSize: 20,
                            fontWeight: 500
                        }}>
                            <p>${wholeData.totalAmount.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize: 14,
                                color: "GrayText"
                            }}>Total Sales</p>
                        </div>
                    </div>
                    <div className='ana-hist-card'>
                        {/* left */}
                        <div style={{ marginRight: 20 }}>
                            <img src={saleImage} alt="count-img" />
                        </div>
                        <div style={{
                            fontSize: 20,
                            fontWeight: 500
                        }}>
                            <p>{wholeData.totalQuantity.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize: 14,
                                color: "GrayText"
                            }}>Total Products Quantity</p>
                        </div>
                    </div>
                    {/* minutes */}
                    <div className='ana-hist-card'>
                        {/* left */}
                        <div style={{ marginRight: 10 }}>
                            <img src={countImage} alt="minutes-img" />
                        </div>
                        <div style={{
                            fontSize: 20,
                            fontWeight: 500
                        }}>
                            <p>{wholeData.totalMinutes.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize: 14,
                                color: "GrayText"
                            }}>Total Minutes</p>
                        </div>
                    </div>
                    {/* calls */}
                    <div className='ana-hist-card'>
                        {/* left */}
                        <div style={{ marginRight: 10 }}>
                            <img src={CallIcon} alt="call-img" height={40} width={40} />
                        </div>
                        <div style={{
                            fontSize: 20,
                            fontWeight: 500
                        }}>
                            <p>{wholeData.totalCalls.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize: 14,
                                color: "GrayText"
                            }}>Total Calls</p>
                        </div>
                    </div>
                </div>
                <Card sx={{ width: "100%", height: "fit-content", marginTop: "20px" }}>
                    {/* <CardContent> */}
                    <div style={{ margin: "10px 10px" }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            // margin:"10px 0px",
                            // padding:15
                        }}>
                            <p style={{ fontWeight: 600, fontSize: 16, color: "GrayText" }}>Stores's All history Data</p>
                            <div style={{
                                display: "flex",
                                position: "relative",
                                borderRadius: 4,
                                padding: 5,
                                height: 40,
                                width: 220,
                                border: "1px solid lightgray",
                                color: "black",
                                alignItems: "center",
                                justifyContent: "space-between",
                                fontSize: 18,
                                margin: "0 20px"
                            }}>
                                {productsFilter.load ? <Spinner color={"green"} /> : <p style={{ marginRight: 5 }}>{productsFilter.value}</p>}
                                <div onClick={() => {
                                    if (productsFilter.load) return
                                    setProductsFilter(p => ({ ...p, open: !p.open }))
                                }}
                                    style={{ cursor: "pointer" }}
                                >
                                    {productsFilter.open ? <KeyboardArrowUpIcon sx={{ padding: 0, margin: 0 }} /> : <KeyboardArrowDownIcon sx={{ padding: 0, margin: 0 }} color="primay" />}
                                </div>


                                {productsFilter.open && <div
                                    style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 40,
                                        // paddingBottom:20,
                                        zIndex: 99,
                                        //   border: "1px solid lightgray",
                                        borderTop: "0px",
                                        borderRadius: 5,
                                        borderTopLeftRadius: 0,
                                        backgroundColor: "#f6f6f7",
                                    }}
                                >
                                    <div className='year-list' style={{ height: 120, overflow: "scroll", overflowX: "hidden" }}>
                                        {productsOptions().map((h, i) => (
                                            <div key={h}
                                                onClick={async (e) => { await handelSelectProductsFilter(e, h) }}
                                                style={{
                                                    cursor: "pointer",
                                                    height: 40,
                                                    width: 220,
                                                    backgroundColor: "",
                                                    // borderBottom: "1px solid lightgray",
                                                    display: "flex",
                                                    padding: 10,
                                                    alignItems: "center",
                                                    fontWeight: 400,
                                                    fontSize: 16,
                                                    color: "#8B8D97",
                                                }}
                                            >
                                                <p>{h}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{
                                margin: "20px 10px",
                                textAlign: "center",

                            }} >
                                <div onClick={() => setAnaCase('m')}
                                    style={{
                                        margin: "5px 0px",
                                        height: 70,
                                        width: 80,
                                        border: "1.5px solid gray",
                                        borderRadius: 4,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: anaCase == 'm' && "rgb(187 187 187)",
                                        cursor: "pointer",
                                    }}>
                                    <div style={{
                                        height: 40,
                                        width: 40,
                                        backgroundColor: "rgba(75, 70, 92, 0.08)",
                                        borderRadius: 10,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <img src={DollarImg} />
                                    </div>
                                </div>
                                <p style={{
                                    fontWeight: 600, fontSize: 16,
                                    letterSpacing: .5,
                                    color: anaCase == 'm' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                    opacity: anaCase !== 'm' && .5
                                }}
                                >Minutes</p>
                            </div>
                            <div style={{
                                margin: "20px 10px",
                                textAlign: "center"
                            }} >
                                <div onClick={() => setAnaCase('s')}
                                    style={{
                                        margin: "5px 0px",
                                        height: 70,
                                        width: 80,
                                        border: "1.5px solid gray",
                                        borderRadius: 4,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: anaCase == 's' && "rgb(187 187 187)",
                                        cursor: "pointer",
                                    }}>
                                    <div style={{
                                        height: 40,
                                        width: 40,
                                        backgroundColor: "rgba(75, 70, 92, 0.08)",
                                        borderRadius: 10,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <img src={DollarImg} />
                                    </div>
                                </div>
                                <p style={{
                                    fontWeight: 600, fontSize: 16,
                                    letterSpacing: .5,
                                    color: anaCase == 'q' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                    opacity: anaCase !== 's' && .5
                                }}
                                >Sales</p>
                            </div>
                            <div style={{
                                margin: "20px 10px",
                                textAlign: "center"
                            }}>
                                <div onClick={() => setAnaCase('q')} style={{
                                    margin: "5px 0px",
                                    height: 70,
                                    width: 80,
                                    border: "1.5px solid gray",
                                    borderRadius: 4,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: anaCase == 'q' && "rgb(187 187 187)",
                                    cursor: "pointer",
                                    fontSize: 24,
                                }}>
                                    <div style={{
                                        height: 40,
                                        width: 40,
                                        backgroundColor: "rgba(75, 70, 92, 0.08)",
                                        borderRadius: 10,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <img src={CartImg} />
                                    </div>
                                </div>
                                <p style={{
                                    fontWeight: 600, fontSize: 16, letterSpacing: .5,
                                    color: anaCase == 'q' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                    opacity: anaCase !== 'q' && .5
                                }}>Quantity</p>
                            </div>

                        </div>
                        {allAnalysis.error?<SectionServerErr/>:<div>
                            {allAnalysis.minutes.length > 0 && anaCase == "m" &&
                                <BarChart color='#3980fd'
                                    labels={storesIds.data.slice(productsFilter.start, productsFilter.end)}
                                    dataSet={allAnalysis.minutes.slice(productsFilter.start, productsFilter.end)}
                                    label={"Total Minutes"} title="Stores's Minutes"

                                />}

                            {allAnalysis.sales.length > 0 && anaCase == "s" &&
                                <BarChart color='#3980fd'
                                    labels={storesIds.data.slice(productsFilter.start, productsFilter.end)}
                                    dataSet={allAnalysis.sales.slice(productsFilter.start, productsFilter.end)}
                                    label={"Total Sales"} title="Stores's Sales"
                                />}
                            {allAnalysis.quantity.length > 0 && anaCase == "q" &&
                                <BarChart color='#3980fd'
                                    labels={storesIds.data.slice(productsFilter.start, productsFilter.end)}
                                    dataSet={allAnalysis.quantity.slice(productsFilter.start, productsFilter.end)}
                                    label={"Total quantities"} title="Stores's Quantities"
                                />}
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                margin: "5px 0 0px 0",
                                color: "red",
                                fontSize: 14,
                                fontWeight: 500,
                            }}>
                                <p>{productsFilter.error}</p>
                            </div>
                            <div style={{
                                // backgroundColor:"red",
                            }}>
                                {allAnalysis.minutes.length > 0 && <TableFooter list={storesIds.data}
                                    visbleList={allAnalysis.minutes}
                                    shownItems={productsFilter}
                                    setShownItems={setProductsFilter}
                                    numOfItems={nOfRes}
                                    onNext={onNextProducts}
                                    hasNext={productsFilter.hasNext}
                                    totalPages={storesIds.count}
                                    isloading={productsFilter.load}
                                    key={productsFilter.value}
                                />}
                            </div>

                        </div>}
                    </div>
                    {/* </CardContent> */}
                </Card>
                <Card sx={{ width: "100%", height: "fit-content", marginTop: "20px", padding: "15px" }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // margin:"10px 0px",
                        // padding:15
                    }}>
                        <p style={{ fontWeight: 600, fontSize: 16, color: "GrayText" }}>Subscription Monthly Overview</p>
                        <div style={{
                            display: "flex",
                            position: "relative",
                            borderRadius: 4,
                            padding: 5,
                            height: 40,
                            width: 220,
                            border: "1px solid lightgray",
                            color: "black",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: 18,
                            margin: "0 20px"
                        }}>
                            {subsFilter.load ? <Spinner color={"green"} /> : <p style={{ marginRight: 5 }}>{subsFilter.label}</p>}
                            <div onClick={() => {
                                if (subsFilter.load) return
                                setSubsFilter(p => ({ ...p, open: !p.open }))
                            }}
                                style={{ cursor: "pointer" }}
                            >
                                {subsFilter.open ? <KeyboardArrowUpIcon sx={{ padding: 0, margin: 0 }} /> : <KeyboardArrowDownIcon sx={{ padding: 0, margin: 0 }} color="primay" />}
                            </div>


                            {subsFilter.open && <div
                                style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 40,
                                    // paddingBottom:20,
                                    zIndex: 99,
                                    //   border: "1px solid lightgray",
                                    borderTop: "0px",
                                    borderRadius: 5,
                                    borderTopLeftRadius: 0,
                                    backgroundColor: "#f6f6f7",
                                }}
                            >
                                <div className='year-list' style={{ height: 120, overflow: "scroll", overflowX: "hidden" }}>
                                    {subsFilters().map((h, i) => (
                                        <div key={h.value}
                                            onClick={async (e) => { await handelSelectSubsFilter(e, h) }}
                                            style={{
                                                cursor: "pointer",
                                                height: 40,
                                                width: 220,
                                                backgroundColor: "",
                                                // borderBottom: "1px solid lightgray",
                                                display: "flex",
                                                padding: 10,
                                                alignItems: "center",
                                                fontWeight: 400,
                                                fontSize: 16,
                                                color: "#8B8D97",
                                            }}
                                        >
                                            <p>{h.label}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{
                            margin: "20px 10px",
                            textAlign: "center",

                        }} >
                            <div onClick={() => setSubsCase('m')}
                                style={{
                                    margin: "5px 0px",
                                    height: 70,
                                    width: 80,
                                    border: "1.5px solid gray",
                                    borderRadius: 4,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: subsCase == 'm' && "rgb(187 187 187)",
                                    cursor: "pointer",
                                }}>
                                <div style={{
                                    height: 40,
                                    width: 40,
                                    backgroundColor: "rgba(75, 70, 92, 0.08)",
                                    borderRadius: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <img src={DollarImg} />
                                </div>
                            </div>
                            <p style={{
                                fontWeight: 600, fontSize: 16,
                                letterSpacing: .5,
                                color: subsCase == 'm' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                opacity: subsCase !== 'm' && .5
                            }}
                            >Minutes</p>
                        </div>
                        <div style={{
                            margin: "20px 10px",
                            textAlign: "center"
                        }} >
                            <div onClick={() => setSubsCase('s')}
                                style={{
                                    margin: "5px 0px",
                                    height: 70,
                                    width: 80,
                                    border: "1.5px solid gray",
                                    borderRadius: 4,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: subsCase == 's' && "rgb(187 187 187)",
                                    cursor: "pointer",
                                }}>
                                <div style={{
                                    height: 40,
                                    width: 40,
                                    backgroundColor: "rgba(75, 70, 92, 0.08)",
                                    borderRadius: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <img src={DollarImg} />
                                </div>
                            </div>
                            <p style={{
                                fontWeight: 600, fontSize: 16,
                                letterSpacing: .5,
                                color: subsCase == 's' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                opacity: subsCase !== 's' && .5
                            }}
                            >Purchase</p>
                        </div>
                    </div>
                    {subs.error ? <SectionServerErr /> : <div style={{
                        minHeight: 300
                    }}>
                        {!subsFilter.load && subs.minutes.length > 0 && subsCase == "m" &&
                            <div>
                                <BarChart dataSet={subs.minutes.slice(subsFilter.start, subsFilter.end)}
                                    labels={storesIds.data.slice(subsFilter.start, subsFilter.end)}
                                    title='Total Subscription minutes'
                                    label={"Subscriptions minutes report"}
                                    color='purple'
                                />
                                <div style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems:"center",
                                    margin: "5px 0 0px 0",
                                    color: "red",
                                    fontSize: 14,
                                    fontWeight: 500
                                }}>
                                    <p>{subsFilter.error}</p>
                                </div>
                                <TableFooter list={storesIds.data}
                                    visbleList={subs.minutes}
                                    shownItems={subsFilter}
                                    setShownItems={setSubsFilter}
                                    numOfItems={nOfRes}
                                    onNext={onNextSubs}
                                    hasNext={subsFilter.hasNext}
                                    totalPages={storesIds.count}
                                    isloading={subsFilter.load}
                                    key={subsFilter.value}
                                />

                            </div>
                        }
                        {!subsFilter.load && subs.money.length > 0 && subsCase == "s" &&
                            <div>
                                <BarChart dataSet={subs.money.slice(subsFilter.start, subsFilter.end)}
                                    labels={storesIds.data.slice(subsFilter.start, subsFilter.end)}
                                    title='Total Subscription purchase'
                                    label={"Subscriptions money report"}
                                    color='lightgreen'
                                />
                                <div style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    margin: "5px 0 0px 0",
                                    color: "red",
                                    fontSize: 14,
                                    fontWeight: 500
                                }}>
                                    <p>{subsFilter.error}</p>
                                </div>
                                <TableFooter list={storesIds.data}
                                    visbleList={subs.money}
                                    shownItems={subsFilter}
                                    setShownItems={setSubsFilter}
                                    numOfItems={nOfRes}
                                    onNext={onNextSubs}
                                    hasNext={subsFilter.hasNext}
                                    totalPages={storesIds.count}
                                    isloading={subsFilter.load}
                                    key={subsFilter.value}
                                />
                            </div>
                        }

                    </div>}
                </Card>
            </div>
    )
}

export default AnalysisSection
